<template>
  <div>
    <div class="widget_heading">
      <h5 class="text-sidebar">
        <i class="fa fa-calculator" aria-hidden="true"></i>
        Simulador de crédito
      </h5>
    </div>
    <div class="financing_calculatoe">
     <div class="form-group">
        <label class="form-label">Valor del vehículo ($)</label>
        <vue-autonumeric
          class="form-control"
          type="text"
          v-model="v_vehiculo"
          placeholder="$" 
          :options="optionsNumeric"
        ></vue-autonumeric>
      </div>
      <div class="form-group">
        <label class="form-label">Cuota inicial ($)</label>
        <vue-autonumeric
          class="form-control"
          type="text"
          v-model="v_inicial"
          placeholder="$" 
          :options="optionsNumeric"
        ></vue-autonumeric>
      </div>
      <div class="form-group">
        <label class="form-label">Valor a financiar ($)</label>
        <vue-autonumeric
          class="form-control"
          type="text"
          :value="calcularMonto(v_vehiculo, v_inicial)"
          disabled
          :options="optionsNumeric"
        ></vue-autonumeric>
      </div>
      <div class="form-group">
        <label class="form-label">Plazo en meses</label>
        <div class="select">
          <select class="form-control" v-model="plazo">
            <option value="12">12 meses</option>
            <option value="24">24 meses</option>
            <option value="36">36 meses</option>
            <option value="48">48 meses</option>
            <option value="60">60 meses</option>
            <option value="72">72 meses</option>
            <option value="84">84 meses</option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <button @click="simularCredito()" class="btn btn-block">
          SIMULAR
        </button>
      </div>
      <div class="form-label m-0 text-muted" v-if="resultado !== null">
        <h6 class="m-0">Cuota Mensual $ {{ v_cuota }}</h6>
      </div>
    </div>
  </div>
</template>

<script>
import { SimuladorSchema } from './validationSchema'
export default {
  data() {
    return {
      v_vehiculo: 0,
      v_inicial: 0,
      plazo: 0,
      v_cuota: 0,
      optionsNumeric: [
        'integerPos',
        {
          digitGroupSeparator: '.',
          decimalCharacter: ',',
        },
      ],
      resultado: null,
      errors: {
        v_vehiculo: '',
        v_inicial: '',
        plazo: '',
      },
    }
  },
  methods: {
    validateYup(path, data) {
      SimuladorSchema.validateAt(path, data)
        .then((res) => {
          this.errors[path] = ''
        })
        .catch((err) => {
          this.errors[path] = err.message
        })
    },
    simularCredito() {
      var monto = this.calcularMonto(this.v_vehiculo, this.v_inicial)
      var tasa = 1.2
      var tasa = tasa / 100.0
      var cuota =
        monto *
        ((tasa * Math.pow(1 + tasa, this.plazo)) /
          (Math.pow(1 + tasa, this.plazo) - 1))
      cuota = cuota.toFixed(0)
      var toInt = parseInt(cuota)
      this.v_cuota = toInt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      this.resultado = true
    },
    calcularMonto(v1, v2) {
      return v1 - v2
    },
  },
}
</script>

<style lang="scss"></style>
